/**
 * The dashboard the site links into (sign-up, sign-in, claim, API keys).
 *
 * NEXT_PUBLIC_APP_URL overrides it so a local stack can walk the whole funnel
 * (shorten → claim → sign up) without being sent to production; compose.yml sets
 * the local dashboard. Kept in its own tiny module because the navbar imports it.
 */
export const APP_URL = (process.env.NEXT_PUBLIC_APP_URL ?? 'https://my.rii.link').replace(/\/$/, '');
export const REGISTER_URL = `${APP_URL}/auth/register`;
export const LOGIN_URL = `${APP_URL}/auth/login`;
